export const API = {
  SEARCH: "/fhir/EODB/Patient",
  PATIENT_DETAILS: "/fhir/EODB/Patient/:id",
  NEW_PATIENT: "/fhir/EODB/Patient",
  LAUNCH_TOKEN: "/auth/token",
  LOCATIONS: "/fhir/EODB/Location?_sort=name&_count=500",
  STATES: "/fhir/EODB/Location?type:text=state&_sort=name&_count=100",
  DISTRICTS_BY_STATE:
    "/fhir/EODB/Location?type:text=district&address:state=:stateName&_sort=name&_count=500",
  PRACTITIONER_ROLES: "/fhir/EODB/PractitionerRole?_count=500",
  USERS_BY_ROLES: "/users/EODB/getUserByRole",
  USER_CHANGE_STATUS: "/users/EODB/changeUserStatus",
  USERS_BULK_IMPORT: "/users/EODB/jobs/users-imports",
  USERS_GET_JOB_STATUS: "/users/EODB/jobStatus/:jobId",
  USERS_GET_JOB_ERROR: "/users/EODB/jobErrors/:jobId",
  USER_DETAILS: "/users/EODB/getUserByEmail/:email",
  PRACTITIONER_ROLES_ID: "/fhir/EODB/PractitionerRole",
  DISTRICT_COUNT:
    "/fhir/EODB/Location?type:text=district&_total=accurate&_count=1",
  STATE_COUNT: "/fhir/EODB/Location?type:text=state&_total=accurate&_count=1",
  USER_BULK_SMS: "/users/EODB/sendsms",
  CITY_VILLAGE_BY_DISTRICTS:
    "/fhir/EODB/Location?type:text=city/village&address-state=:state&address-district=:district&_total=accurate&_sort=name",
  UPDATE_USER: "/users/EODB/updateUser",
  GET_USER_DETAILS: "/users/EODB/getUserById",
  PRACTITIONER: "/Practitioner",
};
